import React, { useCallback, useMemo, useState } from 'react';
import * as yup from 'yup';
import { useStringsContext } from '../../../../../contexts/strings';
import StoryCard from '../story-card';
import { Story, StoryKeys } from '../../types';
import DateTimeWithValidate, {
  DateTimeWithValidateProps,
} from '../../../../common/input/datetime-with-validate';
import moment from 'moment';

interface Props extends Pick<DateTimeWithValidateProps, 'onValidation' | 'hideValidationError'> {
  onValue: (key: string, value: string | boolean | null) => void;
  selectedStory: Story | null;
}

const startTimeKey: StoryKeys = 'startTime';

const StoryScheduleCard = ({
  selectedStory,
  onValue,
  onValidation,
  hideValidationError,
}: Props) => {
  const { strings } = useStringsContext();

  const onChangeEvent = useCallback(
    (key: string, value: string | null) => {
      if (onValue) {
        onValue(key, moment(value).toISOString());
      }
    },
    [onValue]
  );

  const startTimeValue = useMemo(() => {
    return selectedStory?.[startTimeKey]
      ? moment(selectedStory?.[startTimeKey]).format('YYYY-MM-DD HH:mm')
      : '';
  }, [selectedStory]);

  const dateValidation = (() => {
    if (selectedStory) {
      return yup
        .date()
        .required(strings.validations.isRequired)
        .typeError(strings.validations.validDate);
    }

    return yup
      .date()
      .min(moment(), strings.validations.validDateInPast)
      .required(strings.validations.isRequired)
      .typeError(strings.validations.validDate);
  })();

  return (
    <StoryCard title={strings.stories.scheduleTitle} key={selectedStory?.id || ''}>
      <DateTimeWithValidate
        name={startTimeKey}
        validation={dateValidation}
        label={strings.stories.scheduleLabel}
        value={startTimeValue}
        onValue={onChangeEvent}
        onValidation={onValidation}
        hideValidationError={hideValidationError}
      />
    </StoryCard>
  );
};

export default StoryScheduleCard;
